enum EnterpriseCodeEnum {
  entNameMaxChars = 'ENT_NAME_MAX_CHARS',
  entSirenDigitsMin = 'ENT_SIREN_DIGITS_MIN',
  entSirenDigitsMax = 'ENT_SIREN_DIGITS_MAX',
  entVideoSizeMax = 'ENT_VIDEO_SIZE_MAX',
  entThumbnailSizeMax = 'ENT_THUMBNAIL_SIZE_MAX',
  entLogoSizeMax = 'ENT_LOGO_SIZE_MAX',
  entListEstSearchCharsMax = 'ENT_LIST_EST_SEARCH_CHARS_MAX',
  entListApplicationsSearchCharsMax = 'ENT_LIST_APPLICATIONS_SEARCH_CHARS_MAX',
  entListCandidatesElementsMax = 'ENT_LIST_CANDIDATES_ELEMENTS_MAX',
  entListCandSearchAreaRange = 'ENT_LIST_CAND_SEARCH_AREA_RANGE',
  entListCandSearchAreaRangeMin = 'ENT_LIST_CAND_SEARCH_AREA_RANGE_MIN',
  entListCandSearchAreaRangeMax = 'ENT_LIST_CAND_SEARCH_AREA_RANGE_MAX',
  entListCandSearchTagsMax = 'ENT_LIST_CAND_SEARCH_TAGS_MAX',
  entListCandExpMin = 'ENT_LIST_CAND_EXP_MIN',
  entListCandExpMax = 'ENT_LIST_CAND_EXP_MAX',
  entListCandExpRange = 'ENT_LIST_CAND_EXP_RANGE',
  entCandDetailsSimilarProfilesMax = 'ENT_CAND_DETAILS_SIMILAR_PROFILES_MAX',
  entCandDetailsSimilarProfilesExpRange = 'ENT_CAND_DETAILS_SIMILAR_PROFILES_EXP_RANGE',
  entJobOfferDetailsAppElements = 'ENT_JOB_OFFER_DETAILS_APP_ELEMENTS',
  entListEstElements = 'ENT_LIST_EST_ELEMENTS',
  entEstListUsersSearchCharsMax = 'ENT_EST_LIST_USERS_SEARCH_CHARS_MAX',
  entEstListUsersMax = 'ENT_EST_LIST_USERS_MAX',
  entListUserSearchCharsMax = 'ENT_LIST_USER_SEARCH_CHARS_MAX',
  entEstNameCharsMax = 'ENT_EST_NAME_CHARS_MAX',
  entEstSiretDigitsMin = 'ENT_EST_SIRET_DIGITS_MIN',
  entEstSiretDigitsMax = 'ENT_EST_SIRET_DIGITS_MAX',
  entEstListUserElements = 'ENT_EST_LIST_USER_ELEMENTS',
  entEstListUserSearchCharsMax = 'ENT_EST_LIST_USER_SEARCH_CHARS_MAX',
  entJobQualificationMax = 'ENT_JOB_QUALIFICATION_MAX',
  entJobVideoSizeMax = 'ENT_JOB_VIDEO_SIZE_MAX',
  entJobThumbnailSizeMax = 'ENT_JOB_THUMBNAIL_SIZE_MAX',
  entJobTagsMax = 'ENT_JOB_TAG_MAX',
  entJobNameMax = 'ENT_JOB_NAME_MAX',
  entJobReferenceNumberMax = 'ENT_JOB_REFERENCE_NUMBER_MAX',
  entJobSearchCharacterMax = 'ENT_JOB_SEARCH_CHAR_MAX',
}

export default EnterpriseCodeEnum;
